/**
 * SEMU Localization Form Controller
 * Handles country/language selection in header
 */

if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.dropdown = this.querySelector('[data-localization-dropdown]');
        this.countryInput = this.querySelector('input[name="country_code"]');
        this.languageInput = this.querySelector('input[name="locale_code"]');
        this.trigger = document.querySelector('[data-localization-trigger]');

        this.init();
      }

      init() {
        if (!this.trigger) return;

        // Open dropdown on trigger click
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggle();
        });

        // Close on backdrop click
        this.addEventListener('click', (e) => {
          if (e.target === this) {
            this.close();
          }
        });

        // Close on escape key
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.classList.contains('is-active')) {
            this.close();
          }
        });

        // Handle country selection
        const countryButtons = this.querySelectorAll('[data-country-code]');
        countryButtons.forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            const countryCode = button.dataset.countryCode;
            if (this.countryInput && countryCode !== this.countryInput.value) {
              this.countryInput.value = countryCode;
              this.submitForm();
            }
          });
        });

        // Handle language selection
        const languageButtons = this.querySelectorAll('[data-language-code]');
        languageButtons.forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            const languageCode = button.dataset.languageCode;
            if (this.languageInput && languageCode !== this.languageInput.value) {
              this.languageInput.value = languageCode;
              this.submitForm();
            }
          });
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
          if (
            this.classList.contains('is-active') &&
            !this.contains(e.target) &&
            e.target !== this.trigger &&
            !this.trigger.contains(e.target)
          ) {
            this.close();
          }
        });
      }

      toggle() {
        if (this.classList.contains('is-active')) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.classList.add('is-active');
        this.dropdown.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';

        // Close any open menus
        this.closeOtherModals();
      }

      close() {
        this.classList.remove('is-active');
        this.dropdown.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }

      closeOtherModals() {
        // Close search if open
        const searchModal = document.querySelector('.semu-search-modal-wrapper');
        if (searchModal && searchModal.classList.contains('search-is-active')) {
          const searchClose = document.querySelector('[data-close-search]');
          if (searchClose) searchClose.click();
        }

        // Close mobile menu if open
        const mobileMenu = document.querySelector('.mobile-menu-drawer');
        if (mobileMenu && mobileMenu.classList.contains('mobile-menu--open')) {
          const menuClose = document.querySelector('[data-mobile-menu-close]');
          if (menuClose) menuClose.click();
        }
      }

      submitForm() {
        // Show loading state
        this.classList.add('is-submitting');

        // Submit form
        if (this.form) {
          this.form.submit();
        }
      }
    }
  );
}
